module.exports = __webpack_public_path__ + "static/img/doudizhu1.969b918.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/doudizhu1.png
// module id = X1gC
// module chunks = 0